import type { ConsolaInstance } from "consola";

type EventHandler = (ev: { type: string; payload: any }) => void;

/**
 * Making a new Server-Sent Event handler with proper event mapping
 * */
export function makeNewSseHandler<E extends string | number | symbol>(
    endpoint: string,
    eventMap: Record<E, EventHandler>,
    logger: ConsolaInstance
) {
    const evtSource = new EventSource(endpoint, {
        withCredentials: true,
    });
    for (const [event, action] of Object.entries<EventHandler>(eventMap)) {
        evtSource.addEventListener(event, (e: MessageEvent) => {
            logger.trace("Original event", e);
            action({
                type: e.type,
                payload: JSON.parse(e.data),
            });
        });
    }

    return evtSource;
}
